import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../../ReducerRegister";
import EditService from "../../../../../services/screens/admin/dictionary/letter/EditService";
import { ActionTypes } from "../../../../actionTypes/screens/admin/dictionary/letter/EditActionTypes";
import AsyncActionReducers from "../../../../AsyncActionReducers";

import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.dictionary.letter.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveLettersAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_LETTERS_ASYNC, vo });

            EditService.saveLetters(
                vo,
                response => {
                    dispatch(Actions.saveLettersSuccess(response));
                },
                error => {
                    dispatch(Actions.saveLettersFailure(error));
                }
            );
        };
    },

    saveLettersSuccess: data => ({
        type: ActionTypes.SAVE_LETTERS_SUCCESS,
        parentType: ActionTypes.SAVE_LETTERS_ASYNC,
        data
    }),

    saveLettersFailure: error => ({
        type: ActionTypes.SAVE_LETTERS_FAILURE,
        parentType: ActionTypes.SAVE_LETTERS_ASYNC,
        error
    }),

    createLetters: () => ({
        type: ActionTypes.CREATE_LETTERS
    }),
    batchAddLettersAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.BATCH_ADD_LETTERS_ASYNC, vo });

            EditService.batchAddLetters(
                vo,
                response => {
                    dispatch(Actions.batchAddLettersSuccess(response));
                },
                error => {
                    dispatch(Actions.batchAddLettersFailure(error));
                }
            );
        };
    },
    batchAddLettersSuccess: data => ({
        type: ActionTypes.BATCH_ADD_LETTERS_SUCCESS,
        parentType: ActionTypes.BATCH_ADD_LETTERS_ASYNC,
        data
    }),

    batchAddLettersFailure: error => ({
        type: ActionTypes.BATCH_ADD_LETTERS_FAILURE,
        parentType: ActionTypes.BATCH_ADD_LETTERS_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    letter: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, letter: data.letter };
};

const createLettersReducer = (state) => {
    return { ...state, letter: {} };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_LETTERS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_LETTERS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_LETTERS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.BATCH_ADD_LETTERS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.BATCH_ADD_LETTERS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.BATCH_ADD_LETTERS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_LETTERS]: createLettersReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
